/**
 * Valida si un código postal es válido para España
 * Los códigos postales españoles van del 01000 al 52999
 * @param postalCode - El código postal a validar
 * @returns true si es válido, false si no
 */
export const validateSpanishPostalCode = (postalCode: string): boolean => {
  // Verificar que no esté vacío
  if (!postalCode || postalCode.trim() === '') {
    return false;
  }

  // Expresión regular para códigos postales españoles (01000-52999)
  const spanishPostalCodeRegex = /^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/;
  
  return spanishPostalCodeRegex.test(postalCode.trim());
};

/**
 * Obtiene un mensaje de error para códigos postales inválidos
 * @param postalCode - El código postal que falló la validación
 * @returns Mensaje de error descriptivo
 */
export const getPostalCodeErrorMessage = (postalCode: string): string => {
  if (!postalCode || postalCode.trim() === '') {
    return 'El código postal es requerido';
  }

  // Verificar formato básico (5 dígitos)
  if (!/^\d{5}$/.test(postalCode.trim())) {
    return 'El código postal debe tener exactamente 5 dígitos';
  }

  // Verificar rango válido
  const code = parseInt(postalCode.trim());
  if (code < 1000 || code > 52999) {
    return 'Código postal no válido';
  }

  return 'Código postal inválido';
};
